export default "__VITE_ASSET__C6LzMn07__"